import { Checkbox, FormControl, ListItemText, MenuItem, Select, SelectChangeEvent } from '@mui/material';

export interface ISelectInputOption {
  value: string;
  label: string;
}
export interface OwnerTableHeaderMultiSelectInputProps {
  selectedOptions: string[];
  availableOptions: ISelectInputOption[];
  onChange: (event: SelectChangeEvent<string[]>) => void;
}
const OwnersTableHeaderMultiSelectInput = (props: OwnerTableHeaderMultiSelectInputProps) => {
  return (
    <FormControl>
      <Select
        fullWidth
        multiple
        displayEmpty
        value={props.selectedOptions}
        onChange={props.onChange}
        renderValue={(keys) => {
          if (keys.length === 0) {
            return 'Select Options';
          }
          const options = props.availableOptions.filter((s) => keys.includes(s.value)).map((s) => s.label);
          return options.join(', ');
        }}
        inputProps={{ 'aria-label': 'Without label' }}
        style={{ borderRadius: '24px', height: '42px', width: '250px' }}
        MenuProps={{
          PaperProps: {
            sx: {
              borderRadius: '24px',
            },
          },
        }}
      >
        {props.availableOptions.map((availOption) => (
          <MenuItem key={availOption.value} value={availOption.value}>
            <Checkbox checked={props.selectedOptions.indexOf(availOption.value) > -1} />
            <ListItemText primary={availOption.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default OwnersTableHeaderMultiSelectInput;
